import React from "react";
import {css, cx} from "@panda/css";

interface IProps {
    height: string;
    width?: string;
    className?: string;
}

// We want to keep the layout of the box offer same at all times, despite the fact it may be missing some data:
export const NoTagPlug = (props: IProps) => (
    <div className={cx(noTagPlugStyle, props.className)} style={{"--plug-height": props.height, "--plug-width": props.width} as React.CSSProperties} />
);

const noTagPlugStyle = css({
    height: "var(--plug-height)",
    width: "var(--plug-width)"
});
import React from "react";
import {css, cx} from "@panda/css";

interface IProps {
    height: string;
    width?: string;
    className?: string;
}

// We want to keep the layout of the box offer same at all times, despite the fact it may be missing some data:
export const NoTagPlug = (props: IProps) => (
    <div className={cx(noTagPlugStyle, props.className)} style={{"--plug-height": props.height, "--plug-width": props.width} as React.CSSProperties} />
);

const noTagPlugStyle = css({
    height: "var(--plug-height)",
    width: "var(--plug-width)"
});
